import type { AbstractOption } from '~shared/types/abstract-option';

import { useQuery } from '@tanstack/react-query';

export interface UseCountriesReturn {
  countries: AbstractOption[];
  isLoading: boolean;
}

const COUNTRIES_API_URL =
  'https://cdn.skyro.ph/web/apps/cash-loan/resources/countries.json';

const fallbackOptions: AbstractOption[] = [
  { value: 'SA', title: '🇸🇦 Saudi Arabia' },
  { value: 'AE', title: '🇦🇪 United Arab Emirates' },
  { value: 'KW', title: '🇰🇼 Kuwait' },
];

export const useCountries = (): UseCountriesReturn => {
  const { data, isLoading } = useQuery({
    queryKey: ['countries'],
    queryFn: async (): Promise<AbstractOption[]> => {
      const response = await fetch(COUNTRIES_API_URL);

      if (!response.ok) {
        throw new Error(`Failed to fetch countries: ${response.status}`);
      }

      const countries = await response.json();

      return countries;
    },
  });

  return {
    countries: data ?? fallbackOptions,
    isLoading,
  };
};
